import { AppSettings } from "../types/appSettings";
import { actionTypeKeys } from "../../external/actions/actionTypeKeys";
import { Dispatch } from "redux";
import { AppSettingsApi } from "../api/appSettingsApi";
import { handleActionError } from "./actionErrorHandler";

export const loadAppSettingsSuccess = (appSettings: AppSettings) => {
  return {
    type: actionTypeKeys.LOAD_APP_SETTINGS_SUCCESS,
    appSettings
  };
};

export const loadAppSettings = async (dispatchError: boolean = true) => {
  return async (dispatch: Dispatch): Promise<boolean> => {
    try {
      const settings = await AppSettingsApi.GetAppSettings();
      dispatch(loadAppSettingsSuccess(settings));
      return true;
    } catch (error) {
      handleActionError(error, dispatch, dispatchError);
      return false;
    }
  };
};
